const materialsStatusEnum = Object.freeze({
    adicionado: 1,
    atualizado: 2,
    removido: 3
});

export default materialsStatusEnum;
